<template lang="html">
  <div class="proprietary-ems">
    <laptop-svg></laptop-svg>
    <header>
      <span class="notch notch--light notch--lg notch--bm"></span>
      <h2>pmg's proprietary ems</h2>
    </header>

    <section class="ems-desc">
      <h3>Web-Based Scheduling</h3>
      <p>The PMG Event Management System (EMS™) gives access to all event details. From any web-enabled browser, approved users can see at a glance what is happening with the tour. Depending on the level of authority, users can add events, verify the address and local contact information at the venue and confirm event times. We developed this proprietary application to make multiple tours easier to manage. This unique, proprietary event software is property of Promotional Management Group. The program can be modified to include event reminders, follow up surveys and online invitations for each event.</p>
      <h3>Easy to Use</h3>
      <p>Clicking on an event title allows users to view specific event information including location, times, delivery instructions, venue contacts and Intuitive Surgical representative contact information. Once logged in, this web-based data is viewable to Promotional Management Group drivers, management and Intuitive Surgical staff. Updated event information is transferred through the EMS and delivered to the driver via email. The driver is in constant communication with Promotional Management Group and Intuitive Surgical to insure a successful event.</p>
    </section>

  </div>
</template>

<script>
  import LaptopSVG from '@/components/LaptopSVG'
  export default {
    components: {
      'laptop-svg': LaptopSVG
    },
    name: 'proprietary-ems',
    data () {
      return {
        data: {}
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .proprietary-ems {
    position: relative;
    padding: 5rem 1rem;
    background-image: $dark-blue-gradient;
    @include breakpoint($md) {
      padding: 18.750rem 1rem;
    }
    header {
      position: relative;
      margin: 0 auto;
      max-width: 61.250rem;
      text-align: center;
      z-index: 10;
      h2 {
        margin: 0;
        font-family: $montserrat;
        font-size: 2.750rem;
        font-weight: 700;
        color: $white;
        text-transform: uppercase;
      }
    }
  }

  .ems-desc {
    position: relative;
    margin: 4.375rem auto;
    max-width: 64.250rem;
    color: $white;
    z-index: 10;
    h3 {
      margin: 0;
      font-family: $barlowCondensed;
      color: $light-blue;
    }
    @include breakpoint($md) {
      margin: 4.375rem auto 0 9.375rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ProprietaryEms.vue